import { render, staticRenderFns } from "./InvestigationSequences.vue?vue&type=template&id=0ae88d5d&scoped=true&"
import script from "./InvestigationSequences.vue?vue&type=script&lang=js&"
export * from "./InvestigationSequences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae88d5d",
  null
  
)

export default component.exports